// Desactivado temporalmente — pendiente revisión de traducciones al inglés.
// Para reactivar, restaurar el componente original con los botones ES/EN.
export function LanguageSwitcher() {
  return null;
}
